export const feedbackTr = {
  open: 'Geri bildirim ver',
  title: 'Geri bildirim ver',
  description: 'Mevcut sayfadan ayrılmadan sorun, soru veya iyileştirme önerisi bildirin.',
  submit: 'Geri bildirimi gönder',
  submitting: 'Gönderiliyor …',
  types: {
    BUG: 'Bir şey çalışmıyor',
    FEATURE_REQUEST: 'Özellik isteği',
    IMPROVEMENT: 'İyileştirme önerisi',
    USABILITY: 'Kullanım sorunu',
    DATA_ISSUE: 'Veriler yanlış veya eksik görünüyor',
    PERFORMANCE: 'Sayfa yavaş veya yanıt vermiyor',
    QUESTION: 'İşlev hakkında soru',
    OTHER: 'Diğer',
  },
  urgencies: {
    LOW: 'Düşük',
    NORMAL: 'Normal',
    HIGH: 'Yüksek',
    BLOCKING: 'Çalışmaya devam edemiyorum',
  },
  reproducibility: {
    ALWAYS: 'Her zaman',
    SOMETIMES: 'Bazen',
    ONCE: 'Bir kez',
    NOT_TRIED: 'Henüz denenmedi',
  },
  statuses: {
    SUBMITTED: 'Alındı',
    TRIAGED: 'Değerlendirildi',
    IN_PROGRESS: 'İşleniyor',
    RESOLVED: 'Çözüldü',
    CLOSED: 'Kapatıldı',
  },
  priorities: { LOW: 'Düşük', MEDIUM: 'Orta', HIGH: 'Yüksek', CRITICAL: 'Kritik' },
  fields: {
    type: 'Bildirim türü',
    urgency: 'Algılanan aciliyet',
    title: 'Kısa başlık',
    description: 'Ayrıntılı açıklama',
    noSecrets: 'Parola, token, ödeme bilgisi veya gizli içerik girmeyin.',
    attemptedAction: 'Ne yapmayı denediniz?',
    actualResult: 'Gerçekte ne oldu?',
    expectedResult: 'Bunun yerine ne olmasını bekliyordunuz?',
    reproducibility: 'Sorun tekrar edebiliyor mu?',
    reproductionSteps: 'İsteğe bağlı tekrarlama adımları',
    affectedFeature: 'Etkilenen işlev (isteğe bağlı)',
    wantsFollowUp: 'Geri dönüş istiyorum',
    problematicFields: 'Sorunlu alanlar',
    choose: 'Lütfen seçin',
  },
  bug: { title: 'Hata ayrıntıları' },
  screenshot: {
    title: 'Ekran görüntüsü (isteğe bağlı)',
    hint: 'Göndermeden önce gizli alanları kontrol edin ve maskeleyin.',
    choose: 'Görsel seç',
    remove: 'Kaldır',
    invalid: 'Görsel okunamadı.',
    maskArea: 'Ekran görüntüsü maskeleme alanı',
    maskInstructions: 'Gizli alanları kalıcı olarak karartmak için üzerlerinde sürükleyin.',
    resetMasks: 'Maskeleri sıfırla',
  },
  diagnostics: {
    includeExtended: 'Gelişmiş tanılama verilerini ekle',
    title: 'Tanılama verilerini göster',
    transparency:
      'Hangi teknik bölümlerin gönderileceğine siz karar verirsiniz. Doğrulanmış oturum bağlamı sunucu tarafından eklenir.',
    exclusions:
      'Girişler, aramalar, parolalar, tokenlar, mesajlar, dosyalar, pano, ses, kamera, konum ve fare hareketleri hiçbir zaman toplanmaz.',
    sections: {
      APPLICATION: 'Uygulama ve derleme',
      PAGE: 'Geçerli sayfa',
      BROWSER: 'Tarayıcı ve cihaz',
      BREADCRUMBS: 'Son anlamsal eylemler',
    },
  },
  discard: {
    title: 'Taslak silinsin mi?',
    description: 'Gönderilmemiş bilgiler kaybolacak.',
    continue: 'Düzenlemeye devam et',
    confirm: 'Taslağı sil',
  },
  success: {
    title: 'Geri bildirim gönderildi',
    description: 'Sorular için bu referansı saklayın.',
    toast: '{{reference}} geri bildirimi gönderildi.',
  },
  admin: {
    requested: 'Evet',
    nav: 'Geri bildirim merkezi',
    title: 'Geri bildirim merkezi',
    subtitle:
      'Bilinçli olarak gönderilen geri bildirimleri temizlenmiş tanılama bağlamıyla yönetin.',
    loadError: 'Geri bildirimler yüklenemedi.',
    empty: 'Seçilen filtrelere uygun geri bildirim yok.',
    detailTitle: 'Geri bildirim ayrıntıları',
    screenshotAlt: '{{reference}} için maskelenmiş ekran görüntüsü',
    triage: 'Teknik değerlendirme',
    unrated: 'Değerlendirilmedi',
    saved: 'Geri bildirim güncellendi.',
    invalidErrorIds: 'Hata referansları geçersiz.',
    linkedErrors: 'Bağlı sistem hataları',
    kpi: { open: 'Açık bildirimler', untriaged: 'Değerlendirilmemiş', last24h: 'Son 24 saat' },
    columns: {
      reference: 'Referans',
      createdAt: 'Zaman',
      type: 'Tür',
      title: 'Başlık',
      user: 'Kullanıcı',
      status: 'Durum',
    },
    fields: {
      status: 'İşlem durumu',
      priority: 'Teknik öncelik',
      errorIds: 'Hata izleme kimlikleri (virgülle ayrılmış)',
      notes: 'Dahili notlar',
    },
    filters: {
      search: 'Referans, başlık veya açıklama',
      type: 'Türü filtrele',
      status: 'Durumu filtrele',
      priority: 'Önceliği filtrele',
      all: 'Tümü',
    },
    prompt: {
      title: 'Temizlenmiş destek/Copilot istemi',
      hint: 'Metin ve tanılamalar kopyalamadan önce yeniden denetlenir.',
      copy: 'Temizlenmiş istemi kopyala',
      copied: 'Temizlenmiş istem kopyalandı.',
    },
  },
} as const;
